/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ImpressionsInputs */

const en_impressions = /** @type {(inputs: ImpressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressions`)
};

const de_impressions = /** @type {(inputs: ImpressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressionen`)
};

/**
* | output |
* | --- |
* | "Impressions" |
*
* @param {ImpressionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const impressions = /** @type {((inputs?: ImpressionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ImpressionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_impressions(inputs)
	return de_impressions(inputs)
});